var map = {
	"./bank-dice-game.webp": 648,
	"./bw-logo-white.svg": 629,
	"./bw-logo.svg": 734,
	"./country-flag-quiz.webp": 573,
	"./dark-mode.svg": 41,
	"./lani-portfolio.webp": 5,
	"./light-mode.svg": 516,
	"./llc.webp": 269,
	"./monet-app.webp": 287,
	"./profile-circle-light.svg": 952,
	"./profile-circle.svg": 995,
	"./quote-gen.webp": 455,
	"./skopify.webp": 73,
	"./soccer-v2.webp": 492,
	"./soccer.webp": 401,
	"./top-light.svg": 533,
	"./top.svg": 152
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 303;